"use strict";

import React, { Suspense, useEffect } from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { isUserLoggin } from "../_helpers/auth.helper";
import { cookieConstants } from "../_redux/_constants/auth.constants";
import UiMainWrapper from "../components/_uiComponents/common/UiMainWrapper";

import CustomTopHeader from "../components/_uiComponents/common/custom/header/CustomTopHeader";
import CustomFooter from "../components/_uiComponents/common/custom/footer/CustomFooter";

import { SuspenseLoading } from "../components/_uiComponents/common/UiLoadingSpinner";
import ErrorBoundry from "../components/common/ErrorBoundry";

import {
    initThoughtSpot,
    initThoughtspotRestAPI,
} from "../config/thoughtspot-config";

export const useAuth = () => {
    useEffect(function () {
        const isUserLogged = isUserLoggin(cookieConstants.IS_LOGGED_IN);

        if (!isUserLogged) {
            localStorage.removeItem("perfomance-view");
            localStorage.removeItem("voting-view");
        }
    });

    return isUserLoggin(cookieConstants.IS_LOGGED_IN);
};

export function PrivateRoute() {
    const auth = useAuth();
    const location = useLocation();
    const isUserLogged = isUserLoggin(cookieConstants.IS_LOGGED_IN);

    useEffect(() => {
        if (isUserLogged) {
            initThoughtSpot();
            // initThoughtspotRestAPI();
        }
    }, [isUserLogged]);

    const { userProfileDetails } = useSelector((state) => {
        return {
            userProfileDetails: state.auth.userProfileDetails,
        };
    });

    if (!isUserLogged) {
        if (location?.state !== null) {
            localStorage.setItem("pre-path", location.pathname);
        } else {
            localStorage.removeItem("pre-path");
        }
    }

    return auth ? (
        <UiMainWrapper>
            <CustomTopHeader />

            <Suspense fallback={<SuspenseLoading />}>
                <ErrorBoundry>
                    {userProfileDetails?.jobRoleId && <Outlet />}
                </ErrorBoundry>
            </Suspense>

            <CustomFooter />
        </UiMainWrapper>
    ) : (
        <Navigate to="/" />
    );
}

export function PublicRoute({ children }) {
    const preRouter = localStorage.getItem("pre-path");
    const auth = useAuth();

    if (auth) {
        if (preRouter) {
            return <Navigate to={preRouter} />;
        } else {
            return <Navigate to="/app/home" />;
        }
    }

    return children;
}
